import { render } from "./FooterV.vue?vue&type=template&id=8ba3dd64&scoped=true&ts=true"
import script from "./FooterV.vue?vue&type=script&lang=ts"
export * from "./FooterV.vue?vue&type=script&lang=ts"

import "./FooterV.vue?vue&type=style&index=0&id=8ba3dd64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba3dd64"]])

export default __exports__